import React from 'react';
import styles from 'styles/_fonts.module.scss';

type Props = {
  children: React.ReactNode | React.ReactNode[];
  type: keyof typeof styles;
  className?: string;
};

export const Text = ({ children, type, className = '' }: Props) => (
  <span className={`${styles[type]} ${className}`}>{children}</span>
);
